// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2SB0u","container":"INBbS","overlay":"_1a9zH","triangle":"_3Pzg2","right":"_2320Y","top":"_2pdhd"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/profile-actions-widget/profile-actions-widget.scss
// module id = 933
// module chunks = 3 4 5 6 7